import { render, staticRenderFns } from "./HeroEbook.vue?vue&type=template&id=7663caec"
import script from "./HeroEbook.vue?vue&type=script&lang=js"
export * from "./HeroEbook.vue?vue&type=script&lang=js"
import style0 from "./HeroEbook.vue?vue&type=style&index=0&id=7663caec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports